import { defineMessages } from 'react-intl'

const scope = `procurify.modules.expense.feature-sets.ApprovedExpenseItemListSection`

export default defineMessages({
  editModalTitle: {
    id: `${scope}.editModalTitle`,
    defaultMessage: 'Edit approved item',
  },
  editSuccessTitle: {
    id: `${scope}.editSuccessTitle`,
    defaultMessage: 'Success',
  },
  editSuccessMessage: {
    id: `${scope}.editSuccessMessage`,
    defaultMessage: 'Expense item successfully updated.',
  },
  inlineAccountCellLabel: {
    id: `${scope}.inlineAccountCellLabel`,
    defaultMessage: 'Account code for {label}',
  },
})
